import React from 'react'
import { Loader } from 'semantic-ui-react'
import { size, map } from "lodash"
import { PublishedWorksItem } from '../PublishedWorksItem/PublishedWorksItem'
import { Anclas } from '../Anclas/Anclas'

export function PublishedWorks(props) {
    const { works, onReload } = props
    if(!works) return <Loader active inline="centered" />
    if(size(works) === 0) return (<>
      <section id='NoUserPersonalizedHistory'>
        <div id="ContainerIconAnchor">
        <span id="iconAnchor" className="material-symbols-outlined">work</span>
        </div>
  
        <h2>No hay selecciones</h2>
        <p>No te han seleccionado en ningun trabajo</p>
      </section></>)

  return map(works, (work) => <PublishedWorksItem key={work._id} work={work} onReload={onReload} />)
}